import React from 'react';
import { useTranslation } from 'react-i18next';

import '../../languages/i18n';
import './Auth.scss';

import Text from '../../containers/Text';


const SignForm = ({
  email,
  setEmail,
  error,
  identityNumber,
  setIdentityNumber,
  isLoading,
}) => {
  const { t, i18n } = useTranslation();

  return (
    <div className="content-wrapper">
      <div className={'input-wrapper'}>
        <span className="identity-number">
          <Text text={t('identity-number')} />
        </span>
        <input
          autoFocus
          disabled={isLoading}
          type="text"
          required
          inputProps={{ maxLength: 9 }}
          value={identityNumber}
          onChange={(e) => setIdentityNumber(e.target.value.trim())}
          fullWidth
          placeholder={t('enter-ID-number')}
          className={error.active ? 'error' : ''}
        />
      </div>
      <div className={'input-wrapper margin-top--20'}>
        <span className="email">
          <Text text={t('e-mail')} />
        </span>
        <input
          disabled={isLoading}
          type="email"
          name="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value.trim())}
          fullWidth
          placeholder={t('enter-email-address')}
          className={error.active ? 'error' : ''}
        />
      </div>
      {error.active && (
        <div className="auth-error-box">
          <Text text={t(error.key)} />
        </div>
      )}

      <button
        className={`
        lng-button 
        submit-button 
      `}
        disabled={isLoading}
        loading={isLoading}
        type="submit"
      >
        {isLoading ? <div className="spinner"></div> : t('get-one-time-password')}
      </button>
    </div>
  );
};

export { SignForm };
